import { render, staticRenderFns } from "./checkoutV6.vue?vue&type=template&id=5aafc43b&scoped=true"
import script from "./checkoutV6.vue?vue&type=script&lang=js"
export * from "./checkoutV6.vue?vue&type=script&lang=js"
import style0 from "./checkoutV6.vue?vue&type=style&index=0&id=5aafc43b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aafc43b",
  null
  
)

export default component.exports